import { action } from 'typesafe-actions';

import { IShopsAddress, ShopsTypes } from './types';

export const loadRequest = () => action(ShopsTypes.LOAD_REQUEST);
export const loadSuccess = (data: IShopsAddress[]) => action(ShopsTypes.LOAD_SUCCESS, data);
export const loadFailure = () => action(ShopsTypes.LOAD_FAILURE);
